//Mixin de transfert bilatéral du v-model
export const ednValue = {
    data() {
      return {}
    },
    props:{},
    computed: {
        Value: {
            get() {
                return this.value;
            },
            set(newVal) {
                this.$emit('input', newVal);
            }
        }
    },
    methods: {},
}